import React from 'react';
import { CheckboxRegularWrapper, StyledCheckbox } from '../styles';


const CheckboxCell = ({ setSelectedRows, idx, selectedRows, disabled }) => {
    return (
        <CheckboxRegularWrapper>
            <StyledCheckbox
                disabled={disabled}
                type="checkbox"
                checked={selectedRows.includes(idx)}
                onChange={(e) => {
                    if (e.target.checked) {
                        setSelectedRows((prev) => [...prev, idx]);
                    } else {
                        setSelectedRows((prev) => prev.filter((i) => i !== idx));
                    }
                }}
            />
        </CheckboxRegularWrapper>
    );
}
export default CheckboxCell;
